import clientAxios from '../config/axios';

// Obtener todas las plataformas por tenant
export const getAllPlataformaTenants = async () => {
    const response = await clientAxios.get('/plataforma-tenant');
    return response;
};

// Obtener plataformas de un tenant específico
export const getPlataformasByTenantId = async (tenantId) => {
    const response = await clientAxios.get(`/plataforma-tenant/tenant/${tenantId}`);
    return response;
};

// Agregar plataforma a tenant
export const addPlataformaTenant = async (plataformaTenant) => {
    const response = await clientAxios.post('/plataforma-tenant', { plataformaTenant });
    return response;
};

// Actualizar plataforma de tenant
export const updatePlataformaTenant = async (id, updates) => {
    const response = await clientAxios.put('/plataforma-tenant', { id, updates });
    return response;
};

// Eliminar plataforma de tenant
export const deletePlataformaTenant = async (id) => {
    const response = await clientAxios.delete('/plataforma-tenant', { data: { id } });
    return response;
};
